//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data () {
    return {
      id: '',
      baseUrl: process.env.BASE_URL
    }
  },
  computed: {
    options () {
      return this.$t('introduct')
    },
    path () {
      return this.$store.getters.getPath
    }
  },
  components: {
  },
  methods: {

  },
  mounted () {
    let id = ''
    if (this.$route.query.id) {
      id = this.$route.query.id
    }
    this.id = id
  }
}
